import { clientEnv } from "@/config";
import {
  IGeneralData,
  ITokenBase,
  TCreatePasswordPayload,
  TLoginPayload,
  TSendOtpPayload,
  TVerifyOtpPayload,
  TLoginResponseData,
} from "@/interfaces";
import { checkIsToken, fetcher } from "@/lib";
import { signIn, SignInResponse } from "next-auth/react";
import { apiRoutes } from "@/routes/routes";

class AuthClient {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  async login({
    payload: { mobile, password },
  }: {
    payload: TLoginPayload;
  }): Promise<SignInResponse | undefined> {
    const res = await signIn("credentials", {
      redirect: false,
      mobile,
      password,
    });
    if (res && res.error) {
      throw new Error(res.error);
    }
    return res;
  }

  async sendOtp({
    payload,
  }: {
    payload: TSendOtpPayload;
  }): Promise<IGeneralData> {
    const url = apiRoutes.auth.SEND_OTP;
    const otpData = await fetcher<IGeneralData, TSendOtpPayload>({
      url,
      method: "POST",
      payload,
    });
    return otpData;
  }

  async verifyOtp({
    payload: { mobile, otp },
  }: {
    payload: TVerifyOtpPayload;
  }): Promise<SignInResponse | undefined> {
    const res = await signIn("credentials", {
      redirect: false,
      mobile,
      otp,
    });
    if (res && res.error) {
      throw new Error(res.error);
    }
    return res;
  }

  async createPassword({
    payload,
    token,
  }: {
    payload: TCreatePasswordPayload;
  } & ITokenBase): Promise<IGeneralData> {
    checkIsToken(token);
    const url = apiRoutes.auth.CHANGE_PASSWORD;
    const changePasswordData = await fetcher<
      IGeneralData,
      TCreatePasswordPayload
    >({
      url,
      method: "POST",
      payload,
      token,
    });
    return changePasswordData;
  }

  async getUserToken(
    payload: TVerifyOtpPayload,
  ): Promise<IGeneralData<TLoginResponseData>> {
    const url = apiRoutes.auth.VERIFY_OTP;
    const otpData = await fetcher<
      IGeneralData<TLoginResponseData>,
      TVerifyOtpPayload
    >({
      url,
      method: "POST",
      payload,
    });
    return otpData;
  }
}

export const authClient = new AuthClient(clientEnv.NEXT_PUBLIC_API_BASE_URL!);
